import * as i0 from '@angular/core';
import { Component, InjectionToken, Injectable, Optional, Inject, NgModule, SkipSelf } from '@angular/core';
import * as i1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$1 from '@rco/auth-extension';
import { IdleTimeoutConfig, ImproperLogoutConfig, IdleTimeoutService, ImproperLogoutService } from '@rco/auth-extension';
import { of, tap, from, mergeMap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

class LogOutComponent {
    constructor(router) {
        this.router = router;
    }
    handleLogin() {
        this.router.navigate(['/']);
    }
}
LogOutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LogOutComponent, deps: [{ token: i1.Router }], target: i0.ɵɵFactoryTarget.Component });
LogOutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: LogOutComponent, selector: "auth-logout", ngImport: i0, template: "<div class=\"auth-logout\">\n    <div class=\"card\">\n        <div class=\"auth-card-title-container\">\n            <div class=\"image\">\n                <img id=\"logout-image\" class=\"img-fluid\" src=\"assets/images/pwc_medium_logo.png\" alt=\"PwC Logo\">\n            </div>\n            <div class=\"auth-card-title\">\n                <h3 id=\"logout-title\">You have logged out successfully</h3>\n            </div>\n        </div>\n        <div class=\"auth-card-buttons\">\n            <button id=\"login-btn\" type=\"button\" class=\"auth-login-button\" (click)=\"handleLogin()\">\n                Log Back in\n            </button>\n        </div>\n    </div>\n</div>", styles: [".auth-logout{display:flex;justify-content:center;padding:1.5rem}.auth-logout .card{display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;background-color:#fff;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.auth-logout .auth-card-title-container{display:flex;flex-direction:column;align-items:center;padding-top:1.5rem;margin-top:1.5rem}.auth-logout .auth-card-title{padding:.5rem}.auth-logout .auth-card-buttons{padding:1.5rem 0;margin:1.5rem 0}.auth-logout .auth-card-buttons .auth-login-button{background-color:#d04a02;color:#fff;cursor:pointer;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;font-size:14px;font-weight:500}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LogOutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'auth-logout', template: "<div class=\"auth-logout\">\n    <div class=\"card\">\n        <div class=\"auth-card-title-container\">\n            <div class=\"image\">\n                <img id=\"logout-image\" class=\"img-fluid\" src=\"assets/images/pwc_medium_logo.png\" alt=\"PwC Logo\">\n            </div>\n            <div class=\"auth-card-title\">\n                <h3 id=\"logout-title\">You have logged out successfully</h3>\n            </div>\n        </div>\n        <div class=\"auth-card-buttons\">\n            <button id=\"login-btn\" type=\"button\" class=\"auth-login-button\" (click)=\"handleLogin()\">\n                Log Back in\n            </button>\n        </div>\n    </div>\n</div>", styles: [".auth-logout{display:flex;justify-content:center;padding:1.5rem}.auth-logout .card{display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;background-color:#fff;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.auth-logout .auth-card-title-container{display:flex;flex-direction:column;align-items:center;padding-top:1.5rem;margin-top:1.5rem}.auth-logout .auth-card-title{padding:.5rem}.auth-logout .auth-card-buttons{padding:1.5rem 0;margin:1.5rem 0}.auth-logout .auth-card-buttons .auth-login-button{background-color:#d04a02;color:#fff;cursor:pointer;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;font-size:14px;font-weight:500}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.Router }]; } });

/**
 * Representation of the library possible configuration.
 * @class AuthExtensionModuleConfig
 */
class AuthExtensionModuleConfig {
}
/**
 * A representation of an InjectionToken which stores configs related to the library.
 */
const AUTH_EXTENSION_MODULE_CONFIG = new InjectionToken('AUTH_EXTENSION_MODULE_CONFIG', {
    providedIn: 'root',
    factory: AUTH_EXTENSION_MODULE_CONFIG_FACTORY,
});
/**
 * Factory method to create default AuthExtensionModuleConfig
 * for `AUTH_EXTENSION_MODULE_CONFIG` injection token .
 */
function AUTH_EXTENSION_MODULE_CONFIG_FACTORY() {
    return new AuthExtensionModuleConfig();
}

/**
 * A representation of an InjectionToken which stores configs related
 * to idle and timeout services.
 */
const IDLE_TIMEOUT_CONFIG = new InjectionToken('IDLE_TIMEOUT_CONFIG', {
    providedIn: 'root',
    factory: IDLE_TIMEOUT_CONFIG_FACTORY,
});
/**
 * Factory method to create default IdleTimeoutConfig
 * for `IDLE_TIMEOUT_CONFIG` injection token .
 */
function IDLE_TIMEOUT_CONFIG_FACTORY() {
    return new IdleTimeoutConfig();
}

/**
 * A representation of an InjectionToken which stores configs related
 * improper logout.
 */
const IMPROPER_LOGOUT_CONFIG = new InjectionToken('IMPROPER_LOGOUT_CONFIG', {
    providedIn: 'root',
    factory: IMPROPER_LOGOUT_CONFIG_FACTORY,
});
/**
 * Factory method to create default ImproperLogoutConfig
 * for `IMPROPER_LOGOUT_CONFIG` injection token .
 */
function IMPROPER_LOGOUT_CONFIG_FACTORY() {
    return new ImproperLogoutConfig();
}

/**
 * Base service that is reference within the library. Note this
 * a supplied service from `AuthExtensionModule.forRoot()` method hence
 * why error is thrown if no provided.
 */
class AuthService {
    login(url) {
        return of(null);
    }
    getToken() {
        return of('');
    }
    logout() {
        return of(null);
    }
}
AuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Guard used to prevent unauthenticated users from accessing routes. If trying to access
 * a route and currently not authenticated it will automatically start the authentication
 * process. Compatible with CanActivate, CanActivateChild and CanLoad handlers.
 *
 * @example
 * Example of how to use the guard:
  ```
 @NgModule({
   imports: [
      RouterModule.forRoot([
       {
         path: 'root',
          canLoad: [AuthGuard],
          canActivateChild: [AuthGuard],
          children: [
            {
               path: 'team/:id',
               component: TeamComponent
            }
          ]
        }
      ])
    ],
 })
 ```
 */
class AuthGuard {
    constructor(authService) {
        this.authService = authService;
    }
    canActivate(route, state) {
        return this.isAuth(state.url);
    }
    canActivateChild(route, state) {
        return this.isAuth(state.url);
    }
    canLoad() {
        return this.authService.checkIsAuth$;
    }
    isAuth(url) {
        return this.authService.checkIsAuth$.pipe(tap(isAuthenticated => isAuthenticated || this.authService.login(url).subscribe()));
    }
}
AuthGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthGuard, deps: [{ token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AuthService }]; } });

/**
 * Service that monitors for inactivity and emits when a certain threshold is reached.
 *
 * @example
 * The example belows shows passing an {@link IdleTimeoutConfig}:
 * ```
 const idleTimeoutConfig: IdleTimeoutConfig = {
  timeout: 900,
  timeoutWarning: 840
 };

 @NgModule({
    declarations: [],
    imports: [],
    exports: [],
    providers: [
      { provide: IDLE_TIMEOUT_CONFIG, useValue: idleTimeConfig }
    ]
  })
  export class AppModule {}
 * ```
 *
 * @extends IdleTimeoutService
 */
class AuthIdleTimeoutService extends IdleTimeoutService {
    constructor(idleConfig, ngZone) {
        super(idleConfig, ngZone);
    }
}
AuthIdleTimeoutService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthIdleTimeoutService, deps: [{ token: IDLE_TIMEOUT_CONFIG, optional: true }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
AuthIdleTimeoutService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthIdleTimeoutService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthIdleTimeoutService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.IdleTimeoutConfig, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IDLE_TIMEOUT_CONFIG]
                }] }, { type: i0.NgZone }]; } });

/**
 * Interceptor where it attaches current token to incoming requests headers
 * if conditions are met.
 *
 * @example
 * The example belows shows passing a {@link IdleTimeoutConfig}.
 * ```
 const idleTimeoutConfig: IdleTimeoutConfig = {
  timeout: 900,
  timeoutWarning: 840
 };

 @NgModule({
    declarations: [],
    imports: [],
    exports: [],
    providers: [
      { provide: IDLE_TIMEOUT_CONFIG, useValue: idleTimeConfig }
    ]
  })
  export class Module {}
 * ```
 *
 * @extends IdleTimeoutService
 */
class AuthImproperLogoutService {
    constructor(improperLogoutConfig) {
        this.improperLogoutService = new ImproperLogoutService(improperLogoutConfig);
    }
    logout(token) {
        return from(this.improperLogoutService.logout(token));
    }
}
AuthImproperLogoutService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthImproperLogoutService, deps: [{ token: IMPROPER_LOGOUT_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
AuthImproperLogoutService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthImproperLogoutService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthImproperLogoutService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.ImproperLogoutConfig, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IMPROPER_LOGOUT_CONFIG]
                }] }]; } });

/**
 * Class that obfuscates the keys and values from given Web Storage API interface that is provided.
 *
 * @implements Storage
 */
class ObfuscatedStorage {
    constructor(storage, ignoreKeys = ['nonce', 'PKCE_verifier']) {
        this.storage = storage;
        this.ignoreKeys = ignoreKeys;
    }
    clear() {
        this.storage.clear();
    }
    getItem(key) {
        if (this.ignoreKeys.some(k => k === key)) {
            return this.storage.getItem(key);
        }
        else {
            const decodedkey = this.deObfuscate(key) || this.obfuscate(key);
            let value = this.storage.getItem(decodedkey);
            if (typeof value !== 'string') {
                return value;
            }
            const decodedValue = this.deObfuscate(value);
            return JSON.parse(decodedValue);
        }
    }
    key(index) {
        return this.storage.key(index);
    }
    removeItem(key) {
        const decodedkey = this.deObfuscate(key) || this.obfuscate(key);
        return this.storage.removeItem(decodedkey);
    }
    setItem(key, value) {
        if (this.ignoreKeys.some(k => k === key)) {
            this.storage.setItem(key, value);
        }
        else {
            const encodedkey = this.obfuscate(key);
            const encodedValue = this.obfuscate(JSON.stringify(value));
            this.storage.setItem(encodedkey, encodedValue);
        }
    }
    obfuscate(data) {
        return window.btoa(data);
    }
    deObfuscate(data) {
        try {
            return window.atob(data);
        }
        catch (error) {
            return null;
        }
    }
}

/**
 * Interceptor where it attaches current token to headers of outgoing requests.
 *
 * @example
 * The example belows shows passing a {@link AuthExtensionModuleConfig}.
 * ```
 * const authExtensionModuleConfig: AuthExtensionModuleConfig = {
  protectedUrls: ['http://localhost:8080'],
 };

 @NgModule({
    declarations: [],
    imports: [],
    exports: [],
    providers: [
      { provide: AUTH_EXTENSION_MODULE_CONFIG, useValue: authExtensionModuleConfig }
    ]
  })
  export class AppModule {}
 * ```
 */
class AuthInterceptor {
    constructor(authService, authExtensionModuleConfig) {
        this.authService = authService;
        this.defaultTokenType = 'Bearer';
        this.authExtensionModuleConfig = authExtensionModuleConfig;
    }
    /**
    * Intercepts outgoing request and attaches token to headers if `AuthExtensionModuleConfig`
    * token exists.
    */
    intercept(req, next) {
        return this.authService.getToken().pipe(mergeMap(token => {
            const url = req.url.toLowerCase();
            if (!token || !this.authExtensionModuleConfig || !this.authExtensionModuleConfig?.protectedUrls || !this.checkUrl(url))
                return next.handle(req);
            const header = `${this.authExtensionModuleConfig?.tokenType || this.defaultTokenType} ${token}`;
            const headers = req.headers.set('Authorization', header);
            req = req.clone({ headers });
            return next.handle(req);
        }));
    }
    /**
     * Checks if the url exists within the specified `protectedUrls` in
     * `AuthExtensionModuleConfig`. The validation can be overwritten with
     * the use of `protectedUrlValidation' from `AuthExtensionModuleConfig`.
     *
     * @param url - string
     * @returns boolean
     */
    checkUrl(url) {
        if (this.authExtensionModuleConfig?.protectedUrlValidation) {
            return this.authExtensionModuleConfig.protectedUrlValidation(url);
        }
        if (this.authExtensionModuleConfig?.protectedUrls) {
            return !!this.authExtensionModuleConfig?.protectedUrls?.find((u) => url?.toLowerCase().startsWith(u?.toLowerCase()));
        }
        return true;
    }
}
AuthInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthInterceptor, deps: [{ token: AuthService }, { token: AUTH_EXTENSION_MODULE_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
AuthInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AuthService }, { type: AuthExtensionModuleConfig, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [AUTH_EXTENSION_MODULE_CONFIG]
                }] }]; } });

/**
 * Factory method to pass supplied service from root method as AuthService
 * @param authService
 * @returns `Type<AuthAdapterService>`
 */
function authServiceFactory(authService) {
    return authService;
}
/**
 * Module that provides common functionality for authenticating in applications. The module also
 * has the capability to attach current id token to outgoing request if `AuthExtensionModuleConfig`
 * are supplied. This module should only be imported once in the application.
 *
 * @param authService
 * Required and should be a service that implements the AuthAdapterService interface. Refer {@link AuthAdapterService}
 *
 * @param  moduleConfig
 * Configs that is used internally within the library. Refer to {@link AuthExtensionModuleConfig}
 *
 * @example
 * The example belows shows passing config `AuthExtensionModuleConfig.forRoot()` method.
 *
 ```
 const authExtensionModuleConfig: AuthExtensionModuleConfig = {
  protectedUrls: ['http://localhost:8080'],
 };
 @NgModule({
    declarations: [],
    imports: [
       AuthExtensionModule.forRoot({
        authService: SampleAdapterService,
        moduleConfig: authExtensionModuleConfig
      }),
    ]
  })
  export class AppModule {}
 *```
 */
class AuthExtensionModule {
    static forRoot(config) {
        return {
            ngModule: AuthExtensionModule,
            providers: [
                { provide: AuthService, useFactory: authServiceFactory, deps: [config.authService] },
                { provide: AUTH_EXTENSION_MODULE_CONFIG, useValue: config?.moduleConfig },
                { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
            ]
        };
    }
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('AuthExtensionModule is already loaded. Import it in the AppModule only');
        }
    }
}
AuthExtensionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthExtensionModule, deps: [{ token: AuthExtensionModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
AuthExtensionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AuthExtensionModule, declarations: [LogOutComponent], imports: [CommonModule,
        RouterModule] });
AuthExtensionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthExtensionModule, imports: [CommonModule,
        RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AuthExtensionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        LogOutComponent,
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                    ]
                }]
        }], ctorParameters: function () { return [{ type: AuthExtensionModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

/*
 * Public API Surface of angular-auth-extensions
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AUTH_EXTENSION_MODULE_CONFIG, AUTH_EXTENSION_MODULE_CONFIG_FACTORY, AuthExtensionModule, AuthExtensionModuleConfig, AuthGuard, AuthIdleTimeoutService, AuthImproperLogoutService, AuthService, IDLE_TIMEOUT_CONFIG, IDLE_TIMEOUT_CONFIG_FACTORY, IMPROPER_LOGOUT_CONFIG, IMPROPER_LOGOUT_CONFIG_FACTORY, LogOutComponent, ObfuscatedStorage, authServiceFactory };
